import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN_CH from "../config/locales/en-CH.json";
import translationEN_DE from "../config/locales/en-DE.json";
import translationFR from "../config/locales/fr.json";
import translationDE_CH from "../config/locales/de-CH.json";
import translationDE_DE from "../config/locales/de-DE.json";

const resources = {
  "en-CH": {
    translation: translationEN_CH,
  },
  "en-DE": {
    translation: translationEN_DE,
  },
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE_CH,
  },
  "de-CH": {
    translation: translationDE_CH,
  },
  "de-DE": {
    translation: translationDE_DE,
  },
};

const setupI18n = (language) =>
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources,
      lng: language,

      keySeparator: ".",

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });

export default setupI18n;
